/**
 * Converts a server-rendered <time> element into a relative time string
 * (e.g. "2 hours ago") using the native Intl.RelativeTimeFormat.
 *
 * Reads the `datetime` attribute and rewrites the visible text. Progressive enhancement:
 * if `datetime` is missing or unparseable, the server text is left intact.
 */
import { Controller } from "@hotwired/stimulus";

const UNITS = [
  ["year", 60 * 60 * 24 * 365],
  ["month", 60 * 60 * 24 * 30],
  ["week", 60 * 60 * 24 * 7],
  ["day", 60 * 60 * 24],
  ["hour", 60 * 60],
  ["minute", 60],
  ["second", 1],
];

export default class extends Controller {
  connect() {
    const datetime = this.element.getAttribute("datetime");
    if (!datetime) return;

    const date = new Date(datetime);
    if (isNaN(date.getTime())) return;

    this.element.textContent = this.relativeTime(date);
  }

  relativeTime(date) {
    const locale = document.documentElement.lang || "en";
    const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
    const seconds = Math.round((date.getTime() - Date.now()) / 1000);

    for (const [unit, secondsInUnit] of UNITS) {
      if (Math.abs(seconds) >= secondsInUnit || unit === "second") {
        return rtf.format(Math.round(seconds / secondsInUnit), unit);
      }
    }
  }
}
